module.exports = __webpack_public_path__ + "logo@2x.png?1e7831d2ac42b399c23467652df1a2a9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo@2x.png
// module id = 383
// module chunks = 0